// tslint:disable
export var CoverageType;
(function (CoverageType) {
    // INS
    CoverageType[CoverageType["INS"] = 3] = "INS";
    // PBM
    CoverageType[CoverageType["PBM"] = 4] = "PBM";
    // PAYER
    CoverageType[CoverageType["PAYER"] = 32] = "PAYER";
})(CoverageType || (CoverageType = {}));
//# sourceMappingURL=CoverageType.js.map